
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { SettingsHeader } from "@/components/settings/SettingsHeader";
import { ProfileSettings } from "@/components/settings/ProfileSettings";
import { PreferencesSettings } from "@/components/settings/PreferencesSettings";
import { SecuritySettings } from "@/components/settings/SecuritySettings";
import { DeliverySettings } from "@/components/settings/delivery/DeliverySettings";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import { ResetDataDialog } from "@/components/settings/ResetDataDialog";

const Settings = () => {
  const [isResetDialogOpen, setIsResetDialogOpen] = useState(false);

  return (
    <DashboardLayout userType="owner">
      <div className="space-y-6">
        <SettingsHeader />
        
        <Tabs defaultValue="profile" className="space-y-6">
          <TabsList>
            <TabsTrigger value="profile">Profil</TabsTrigger>
            <TabsTrigger value="preferences">Préférences</TabsTrigger>
            <TabsTrigger value="delivery">Livraison</TabsTrigger>
            <TabsTrigger value="security">Sécurité</TabsTrigger>
          </TabsList>

          <TabsContent value="profile" className="space-y-6">
            <ProfileSettings />
          </TabsContent>

          <TabsContent value="preferences" className="space-y-6">
            <PreferencesSettings />
          </TabsContent>

          <TabsContent value="delivery" className="space-y-6">
            <DeliverySettings />
          </TabsContent>

          <TabsContent value="security" className="space-y-6">
            <SecuritySettings />
            <div className="border-t pt-6">
              <h3 className="text-lg font-medium mb-4">Zone de danger</h3>
              <div className="bg-destructive/10 p-4 rounded-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium text-destructive">Réinitialiser les données</h4>
                    <p className="text-sm text-muted-foreground mt-1">
                      Supprimer toutes les données de votre compte (produits, transactions, etc.)
                    </p>
                  </div>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => setIsResetDialogOpen(true)}
                  >
                    <Trash2 className="w-4 h-4 mr-2" />
                    Réinitialiser
                  </Button>
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>

        <ResetDataDialog
          open={isResetDialogOpen}
          onOpenChange={setIsResetDialogOpen}
        />
      </div>
    </DashboardLayout>
  );
};

export default Settings;
